.wrap {
  position: relative;
  min-height: 420px;
}

.glow {
  position: absolute;
  inset: 10% 5%;
  background: radial-gradient(
    circle,
    rgba(124, 58, 237, 0.35),
    transparent 70%
  );
  filter: blur(40px);
  pointer-events: none;
}

.window {
  position: absolute;
  border: 1px solid var(--color-border-strong);
  border-radius: var(--radius-md);
  background: var(--color-bg-elevated);
  box-shadow: 0 20px 50px rgba(0, 0, 0, 0.45);
  overflow: hidden;
}

.titleBar {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 10px 12px;
  border-bottom: 1px solid var(--color-border);
  background: rgba(0, 0, 0, 0.3);
}

.dot {
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.15);
}

.winTitle {
  margin-left: 8px;
  font-size: 11px;
  font-weight: 600;
  color: var(--color-text-muted);
}

.editor {
  top: 0;
  left: 0;
  width: 62%;
  z-index: 1;
}

.body {
  overflow: hidden;
  background: #0a0810;
  line-height: 0;
}

.control {
  top: 24%;
  right: 0;
  width: 54%;
  z-index: 2;
}

.presentation {
  bottom: 0;
  left: 10%;
  width: 72%;
  z-index: 3;
}

@media (max-width: 900px) {
  .wrap {
    display: none;
  }
}
